// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__xriy3","input":"contact_input__2Uor1","formControl":"contact_formControl__jr5Z1"};